<template>
  
  <rect
    :style  = "style"
    :x      = "shape.x"
    :y      = "shape.y"
    :width  = "shape.width"
    :height = "shape.height"

    @contextmenu.prevent = "$emit('contextmenu', $event);"
    @mousedown.prevent   = "$emit('mousedown', $event);"
  />

</template>

<script>

export default {

  // #region Properties

  props: {
    shape: Object
  },
  computed: {
    style() {
      return {
        'fill':          'transparent',
        'vector-effect': 'non-scaling-stroke',
        'stroke':        this.shape.color,
        'stroke-width':  '4'
      }
    }
  }

  // #endregion Properties

}

</script>